import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NOTIFICATION_ACTION_EVENT, type NotificationActionDetail } from "@/fcm";

/**
 * Listens for notification tap (deep link) events dispatched from fcm.ts
 * and navigates to the target path (e.g. /case/123).
 */
export function NotificationActionListener() {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e: CustomEvent<NotificationActionDetail>) => {
      const { path } = e.detail ?? {};
      if (path) navigate(path);
    };
    window.addEventListener(
      NOTIFICATION_ACTION_EVENT,
      handler as EventListener
    );
    return () =>
      window.removeEventListener(
        NOTIFICATION_ACTION_EVENT,
        handler as EventListener
      );
  }, [navigate]);

  return null;
}
